exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".equipment-summary-container[data-v-53935346]{background:#fff;border-radius:2px;box-shadow:0 2px 8px 0 rgba(0,0,0,.25)}.title-bar[data-v-53935346]{background:#f6f6f6;color:#9e9e9e;padding:.8rem 1rem .8rem 2.4rem;display:flex;align-items:center}.title-bar img[data-v-53935346]{max-width:20px;margin-right:.9rem}.equipment-row[data-v-53935346]{display:flex;padding:1.5rem 2rem}.equipment-image[data-v-53935346]{max-width:50px;margin-right:1.875rem}", ""]);

// exports
